import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ROUTES } from "./routes";
import FormContainer from "./components/containers/FormContainer";
import Constants from "./constants/Constants";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { theme } from "./theme/theme";
import { Header } from "./components/Header";
import Mask from "./components/Mask";
import { SnackbarProvider } from "notistack";
import Navigation from "./components/Navigation";
import { ConfirmProvider } from "material-ui-confirm";
import UnsupportedBrowserWarning from "./components/UnsupportedBrowserWarning";

const SkydivingOccurrenceReport = React.lazy(() => import("./components/forms/SkydivingOccurrenceReport"));
const VoluntaryOccurrenceReport = React.lazy(() => import("./components/forms/VoluntaryOccurrenceReport"));
const MandatoryOccurrenceReport = React.lazy(() => import("./components/forms/mandatory/MandatoryOccurrenceReport"));
const EccairsPdfUpload = React.lazy(() => import("./components/forms/EccairsPdfFormUpload"));

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        autoHideDuration={Constants.MESSAGE_DISPLAY_DURATION}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
      >
        <UnsupportedBrowserWarning />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ConfirmProvider>
            <Header />
            <Router basename={Constants.CONTEXT_PATH}>
              <FormContainer>
                <Routes>
                  <Route path={ROUTES.ROOT} element={<Navigation />} />

                  <Route
                    path={ROUTES.SKYDIVING_FORM}
                    element={
                      <Suspense fallback={<Mask />}>
                        <SkydivingOccurrenceReport />
                      </Suspense>
                    }
                  />
                  <Route
                    path={ROUTES.VOLUNTARY_OCCURRENCE_FORM}
                    element={
                      <Suspense fallback={<Mask />}>
                        <VoluntaryOccurrenceReport />
                      </Suspense>
                    }
                  />
                  <Route
                    path={ROUTES.MANDATORY_OCCURRENCE_FORM}
                    element={
                      <Suspense fallback={<Mask />}>
                        <MandatoryOccurrenceReport />
                      </Suspense>
                    }
                  />
                  <Route
                    path={ROUTES.ANNEX_1_AIRCRAFT}
                    element={
                      <Suspense fallback={<Mask />}>
                        <MandatoryOccurrenceReport titleKey="nav.annex1" type="ANNEX_1" />
                      </Suspense>
                    }
                  />
                  <Route
                    path={ROUTES.ECCAIRS_PDF_UPLOAD_FORM}
                    element={
                      <Suspense fallback={<Mask />}>
                        <EccairsPdfUpload />
                      </Suspense>
                    }
                  />
                </Routes>
              </FormContainer>
            </Router>
          </ConfirmProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
